export const PROMOTION_SEARCH_PARAMETERS = [
	  {
    id: 1,
    parameter: 'p.razao_social_nome',
    text: 'Nome',
  },
  {
    id: 2,
    parameter: 'id_visita',
    text: 'Codigo da Visita',
  },
  {
    id: 3,
    parameter: 'data',
    text: 'Data da Visita',
  },

]
